<template lang="pug">
.pay
  .info
    .head Всего к оплате
    .row
      .text Товары ({{ itemsCount }})
      .text {{ totalOldPrice }} ₽
    .row(v-if="totalDiscount")
      .text Скидка
      .text – {{ totalDiscount }} ₽
    .promo
      .input
        input(
          placeholder="Ввести промокод"
          v-model="promocode"
          @keyup.enter="onApplyAction"
        )
        button(
          v-if="isPromoButtonVisible"
          @click="onApplyAction"
        )
          ui-svg-icon(
            name="check"
            :size="20"
            :originalColors="true"
          )
      .errorText(v-if="promocodeError") {{ promocodeText }}
    template(v-if="isPromocodeApplied")
      .promo.apply
        .text ✓ {{ promocodeText }}
  .total
    .row
      .head Итого
      .totalPrice {{ totalPrice }} ₽
    ui-button.button(color="blue-lecta" @click="onBasketPayClick") Купить
</template>

<script>
import { computed, inject, ref } from 'vue'
export default {
  setup () {
    const store = inject('store')
    const promocode = ref('')

    const onClearInputPromocode = () => {
      promocode.value = ''
    }
    const onApplyAction = () => {
      store.basket.applyPromocode(promocode.value)
    }
    const isPromoButtonVisible = computed(() => {
      if (promocode.value === '') return false
      return true
    })

    const promocodeError = computed(() => store.basket.data?.promocode && !store.basket.data?.promocode?.isValid)
    const promocodeText = computed(() => store.basket.data?.promocode?.message)
    const promocodeClass = computed(() => ({ error: promocodeError.value }))
    const isPromocodeApplied = computed(() => store.basket.data?.promocode?.isValid)
    const itemsCount = computed(() => store.basket.data?.itemsCount)
    const totalOldPrice = computed(() => store.basket.data?.totalPrice)
    const totalDiscount = computed(() => store.basket.data?.totalDiscount)
    const totalPrice = computed(() => store.basket.data?.totalNewPrice || store.basket.data?.totalPrice)

    store.basket.$on('getPaymentLink', () => {
      window.location.href = store.basket.paymentLink
    })

    const onBasketPayClick = () => {
      if (store.user.isAuthenticated) store.basket.getPaymentLink()
      else store.user.login()
    }

    return { onClearInputPromocode, totalPrice, totalDiscount, totalOldPrice, itemsCount, isPromocodeApplied, promocode, promocodeError, promocodeText, promocodeClass, onApplyAction, isPromoButtonVisible, onBasketPayClick }
  }
}
</script>

<style lang="sass">
.pay
  margin-top: 10.5*$u
  border-radius: 10px
  padding: 6*$u
  width: 270px
  background-color: $cWhite
  height: fit-content
  right: calc((100vw - (100vw - 100%) - #{$appMaxWidth - 18*$u}) / 2)
  transition: .2s
  &.fixed
    margin-top: 0
    position: fixed
    top: 0
  @media (max-width: $appMaxWidth)
    right: 9*$u
  @media (max-width: $padWidth)
    right: 5*$u
  @media (max-width: $XLWidth)
    margin-top: 0
  @media (max-width: $XSWidth)
    width: 100%
    position: inherit
  .info
    border-bottom: 1px solid $lectaGrey
    .head
      margin-bottom: 4*$u
      font-family: GolosTextWebDemiBold, serif
      font-size: 20px
      line-height: 24px
    .promo
      margin: 6*$u 0
      display: flex
      flex-direction: column
      > .errorText
        font-size: 12px
        font-family: GolosTextWebMedium
        color: $basketError
        margin-top: $u
      &.error
        input
          border: 1px solid $basketError
        button
          background-color: $basketError
      &.apply
        color: $cGreen
        font-family: GolosTextWebRegular
        font-size: 3*$u
        svg
          fill: $cGreen
  .total
    margin-top: 20px
    .totalPrice
      @include font('h3')
      line-height: 24px
      color: $lectaBlue
    .gift
      margin: 3*$u 0 6*$u
    .button
      margin-top: 6*$u
      width: 100%
      height: 9*$u
  .row
    display: flex
    justify-content: space-between
    align-items: center
    margin-bottom: 2*$u
    .text
      font-family: GolosTextWebRegular, serif
      font-size: 16px
  .head
    font-family: GolosTextWebDemiBold, serif
    font-size: 20px
    line-height: 24px
  .input
    display: flex
    position: relative
    input
      width: 100%
      border-radius: $u
      border: 1px solid $lectaGrey
      padding: 2*$u 3*$u
      @include font('t14-regular')
      &.inputGift
        margin-bottom: 6*$u
    button
      position: absolute
      width: 10*$u
      height: 9*$u
      right: 0
      height: 100%
      border-radius: 0 $u $u 0
      background-color: $lectaBlue
      color: $cWhite
      border: none
      display: flex
      justify-content: center
      align-items: center
</style>
